import type { EventHandler } from './event-emitter.types'

export class EventEmitter {
  private readonly listeners = new Map<string, Set<EventHandler>>()

  on<T = unknown>(event: string, handler: EventHandler<T>): () => void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set())
    }

    const handlers = this.listeners.get(event)
    handlers?.add(handler as EventHandler)

    return () => {
      this.off(event, handler as EventHandler)
    }
  }

  off(event: string, handler: EventHandler): void {
    const handlers = this.listeners.get(event)
    if (handlers) {
      handlers.delete(handler)
      if (handlers.size === 0) {
        this.listeners.delete(event)
      }
    }
  }

  emit(event: string, data?: unknown): void {
    const handlers = this.listeners.get(event)
    if (handlers) {
      handlers.forEach((handler) => {
        try {
          handler(data)
        } catch (error) {
          console.error(`[WidgetSDK] Error in event handler for "${event}":`, error)
        }
      })
    }
  }

  removeAllListeners(event?: string): void {
    if (event) {
      this.listeners.delete(event)
    } else {
      this.listeners.clear()
    }
  }

  hasListeners(event: string): boolean {
    const handlers = this.listeners.get(event)
    return handlers !== undefined && handlers.size > 0
  }
}
